import PageTitle from '../../components/pagetitle/PageTitle'

import Accordion from '../../components/FaqSection/Accordion';
import ServiceSidebar from './sidebar'

import simag from '../../images/service/b.jpg'
import Gimg1 from '../../images/cta-bg.jpg'
import Gimg2 from '../../images/cta-2.jpg'
import Gimg3 from '../../images/cta-2.jpg'
import Gimg4 from '../../images/cta-4.jpg'


const SeaFreight = ({ serviceDetails }) => {
    return (
        <>
            <section className={`wpo-breadcumb-area ${serviceDetails.slug}`}>
                <PageTitle pageTitle={'International Logistics'} pagesub={serviceDetails.title} />
            </section>
            <section id='details' className='wpo-service-single-page section-padding'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-12 order-lg-2">
                            <div className="service-single-wrap">
                                <h2 className='mt-0'>{serviceDetails.title}</h2>
                                <div className="title-image">
                                    <img src={simag} alt="" />
                                </div>

                                <p>
                                    Ocean freight is a critical component of multimodal transportation services. To offer the best service possible, we have a dedicated Ocean Freight Department specializing in FCL, LCL, break-bulk, project cargo, and various types of cargo globally. Our worldwide services include port-to-port shipments and complete door-to-door supply chain solutions. Over the years, Overflow Logistics has built strong business relationships with all major international and regional ocean carriers.
                                </p>

                                <div className="fc-gray my-4">
                                    <h5>
                                        Services Include:
                                    </h5>
                                    <ul className="list-unstyled mt-3 fs-6">
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Import and Export FCL and LCL
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Break-Bulk, Dry & Liquid Bulk Services
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Issuance and Verification of Shipping Documentation
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Export and Import Customs Clearance
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Certified Industrial Packing and Crating
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Packing and Crating of Household Goods
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Warehousing, Assembly and Distribution Logistics
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Letter of Credit Processing
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Part & Full Vessel Charter
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Conventional Shipments
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Sea/air Transportation
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Sea/Road and Sea/Rail Intermodal Services
                                        </li>
                                        <li className='mb-2 position-relative ps-4'>
                                            <i className="fa-solid fa-circle-check text-success me-2 position-absolute start-0 mt-1"></i>
                                            Transport and Marine Insurance
                                        </li>
                                    </ul>
                                </div>

                                <h3 className="quate">
                                    Sea freight is a cornerstone of global trade, ensuring efficient, cost-effective, and secure movement of goods across oceans while supporting international supply chains and economic growth.
                                </h3>

                                <div className="image-gallery">
                                    <h2>Eligibility checklist :</h2>
                                    <ul>
                                        <li><img src={Gimg1} alt="" /></li>
                                        <li><img src={Gimg2} alt="" /></li>
                                        <li><img src={Gimg3} alt="" /></li>
                                        <li><img src={Gimg4} alt="" /></li>
                                    </ul>
                                </div>
                                <Accordion />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 order-lg-1">
                            <ServiceSidebar />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SeaFreight